import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-container" style={{ textAlign: 'center', padding: '100px' }}>
      <h1>404</h1>
      <h2>Oops! Page not found.</h2>
      <p>The page you are looking for does not exist.</p>
      <button onClick={() => navigate('/')} style={{ padding: '10px 20px', marginTop: '20px' }}>
        Go to Home
      </button>
    </div>
  );
}

export default NotFound;
